import { invokeEdgeFunction } from './invokeEdgeFunction';
import type { PersonalizeChangeNote } from './personalization';

export type PersonalizationPreviewOutcome = 'completed' | 'skipped' | 'failed';

export interface PersonalizationPreviewResult {
  outcome: PersonalizationPreviewOutcome;
  base: { subject: string; body_html: string };
  result?: { subject: string; body_html: string };
  profile_score: number | null;
  profile_score_tier: string | null;
  min_score: number;
  skip_reason?: string;
  error?: string;
  context_snapshot?: Record<string, unknown>;
  context_payload?: Record<string, unknown>;
  changes?: PersonalizeChangeNote[];
  subscriber_email?: string | null;
  prompt?: { model: string; system: string; user: string };
}

export interface PreviewEmailPersonalizationInput {
  scheduled_email_id?: string;
  subscriber_id?: string;
  subject?: string;
  body_html?: string;
  min_score?: number;
}

/**
 * Dry-run AI personalization for admin preview (no DB writes).
 */
export async function previewEmailPersonalization(
  input: PreviewEmailPersonalizationInput,
): Promise<PersonalizationPreviewResult> {
  return invokeEdgeFunction<PersonalizationPreviewResult>('preview-email-personalization', input);
}
